import React from 'react';

import styles from './customCheckbox.module.scss';

const CustomCheckbox = ({ type, id, checked, onCheckboxChange, disabled = false }) => (
  <div className={styles.customCheckboxContainer}>
    <input
      type="checkbox"
      name={type}
      value={id}
      id={type}
      checked={checked}
      onChange={onCheckboxChange}
      disabled={disabled}
      className={`${styles.checkbox} ${disabled && !checked ? styles.noBgImage : ''}`}
    />
    <label className={styles.labelCheckboxText} key={type} htmlFor={type}>
      {type}
    </label>
  </div>
);

export default CustomCheckbox;
